
export const pricing = {
  'request.pricing': 'طلب الأسعار',
  'view.pricing': 'عرض الأسعار',
  'product.pricing': 'أسعار المنتجات',
};
